import { Reducer } from 'redux';
import * as _ from 'lodash';
import { NotificationState } from '../models/notification-state';
import { NotificationActionTypes } from '../actions/notifications';
import { Notification } from '../models/notification';

const initialState: NotificationState = {
    items: [],
    unread: 0
}

export const notifications: Reducer<NotificationState> = (state: NotificationState = initialState, action: any) => {
    switch(action.type) {
        case NotificationActionTypes.NOTIFICATONS_GET_SUCCESS:
            return action.data;

        case NotificationActionTypes.NOTIFICATONS_MARK_AS_READ:
            return {
                items: state.items.map((item) => {
                    if (item.id !== action.id) {
                        return item;
                    }

                    return {
                        ...item,
                        is_read: true
                    }
                }),
                unread: state.unread -1
            }
        
        case NotificationActionTypes.NOTIFICATONS_MARK_ALL_AS_READ:
            return {
                items: markAsRead(state.items, action.ids),
                unread: state.unread - action.ids.length
            }
            
        default:
            return state;
    }
}

function markAsRead(items: Notification[], ids: string[]) {
    return items.map((item) => {
        const index = _.indexOf(ids, item.id);
        if (index === -1) {
            return item;
        }

        return {
            ...item,
            is_read: true
        }
    });
}